/**
 * Extracts plain text from HTML by stripping all tags.
 * Used to check if HTML content has any visible text.
 */
export const htmlToPlainText = (html: string): string => {
  const parser = new DOMParser();
  const doc = parser.parseFromString(html, 'text/html');
  return doc.body.textContent || '';
};
